// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function prefixLog(msg) {
  return "[nav optimize] " + msg;
}
function logsEnabled(param) {
  return Caml_obj.equal(Caml_option.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_logs")), "true");
}
function log(msg) {
  if (logsEnabled(undefined)) {
    console.log("[nav optimize] " + msg);
    return;
  }
}
function log2(msg, data) {
  if (logsEnabled(undefined)) {
    console.log("[nav optimize] " + msg, data);
    return;
  }
}
function tap(data, fn) {
  Curry._1(fn, data);
  return data;
}
function log2$1(data, msg) {
  log2(msg, data);
  return data;
}
var Tap = {
  tap: tap,
  log2: log2$1
};
function getResults(param) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(window.maker_optimize, function (prim) {
    return prim.results;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), {});
}
function getWinners(param) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(window.maker_optimize, function (prim) {
    return prim.winners;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), []);
}
function notifyDebugger(param) {
  window.dispatchEvent(new Event("makerOptimizeUpdate"));
}
function logResults(experimentId, clearOpt, results) {
  var clear = clearOpt !== undefined ? clearOpt : false;
  var current = getResults(undefined);
  var currentExperiment = Belt_Option.getWithDefault(Js_dict.get(current, experimentId), []);
  var currentExperimentWinner = Belt_Array.concatMany(Belt_Array.map(currentExperiment, function (results) {
    return Belt_Array.concat(Belt_Option.getWithDefault(results.conditions.all, []), Belt_Option.getWithDefault(results.conditions.any, []));
  }));
  var newResults = Belt_Array.concatMany(Belt_Array.map(results, function (results) {
    return Belt_Array.concat(Belt_Option.getWithDefault(results.conditions.all, []), Belt_Option.getWithDefault(results.conditions.any, []));
  }));
  var currentExperimentWinner$1 = currentExperimentWinner.length !== 0 && currentExperimentWinner.length > newResults.length && Belt_Array.reduce(currentExperimentWinner, true, function (acc, result) {
    if (acc) {
      return result.result;
    } else {
      return false;
    }
  });
  if (!currentExperimentWinner$1) {
    var currentExperiment$1 = clear ? [] : currentExperiment;
    current[experimentId] = Belt_Array.concat(currentExperiment$1, results);
    Belt_Option.forEach(window.maker_optimize, function (__x) {
      __x.results = current;
    });
  }
  notifyDebugger(undefined);
}
function logFacts(facts) {
  Belt_Option.forEach(window.maker_optimize, function (__x) {
    __x.facts = facts;
  });
}
function logWinner(experimentId, reason, variantId) {
  var current = getWinners(undefined);
  var exists = Belt_Array.some(current, function (winner) {
    if (Caml_obj.equal(winner.experimentId, experimentId) && winner.variantId === variantId) {
      return Caml_obj.equal(winner.reason, reason);
    } else {
      return false;
    }
  });
  if (exists) {
    return;
  }
  var winners = Belt_Array.concat(current, [{
    experimentId: experimentId,
    variantId: variantId,
    reason: reason
  }]);
  Belt_Option.forEach(window.maker_optimize, function (__x) {
    __x.winners = winners;
  });
  notifyDebugger(undefined);
}
export { prefixLog, logsEnabled, log, log2, Tap, getResults, getWinners, notifyDebugger, logResults, logFacts, logWinner };
/* No side effect */